<script lang="ts">
	import { t } from 'svelte-i18n';
	import ButtonFilters from '$lib/elements/buttons/variants/ButtonFilters.svelte';
	import type { FiltersGroup } from '@app/types/Filters';
	import type { InputTextProps } from '$lib/elements/inputs/types';
	import { getNumberOfActiveFilters } from './filters';
	import FiltersHorizontalLayout from './FiltersHorizontalLayout.svelte';
	import { viewport } from '$lib/stores';

	export let numberOfResults = 0;
	export let filtersGroups: FiltersGroup[] = [];
	export let searchQueryProps: InputTextProps;

	let modal = null;
	let numberOfSelectedFilters;

	const loadFiltersModal = async () => {
		if (searchQueryProps) {
			searchQueryProps.value = undefined;
		}
		const { default: FiltersModal } = await import('./FiltersModal.svelte');
		modal = FiltersModal;
	};

	const closeFiltersModal = () => {
		modal = null;
	};

	$: numberOfSelectedFilters = getNumberOfActiveFilters(filtersGroups);
</script>

{#if $viewport.isMobile}
	<ButtonFilters {numberOfSelectedFilters} on:click={() => loadFiltersModal()} />
	<svelte:component
		this={modal}
		{numberOfResults}
		{filtersGroups}
		ctaLabel={$t('projectsPage.displayProjectsModal')}
		on:closeModal={() => closeFiltersModal()}
	/>
{:else}
	<FiltersHorizontalLayout
		{filtersGroups}
		{numberOfResults}
		ctaLabel="projectsPage.displayProjects"
	/>
{/if}
